import React from 'react';

// Active filters as removable chips + one-tap quick filters + add/clear.
// activeFilters: [{key,label,onRemove}]. quickFilters: [{key,label,active,onToggle}].
export default function ProductFilterChips({ t, activeFilters, quickFilters, inlineNode, onOpenPanel, onClearAll }) {
  return (
    <div>
      {/* Top row: stable controls — never shift as active filters change. */}
      <div className="pux-chips-row">
        {inlineNode}
        {inlineNode && quickFilters.length > 0 && <span style={{ width:1, height:18, background:'#e5e7eb' }} />}
        {quickFilters.map(q => (
          <button key={q.key} type="button" className="pux-fchip" style={{ cursor:'pointer', background: q.active ? '#dbeafe' : '#f3f4f6' }} onClick={q.onToggle}>{q.label}</button>
        ))}
        <button type="button" className="pux-fchip pux-fchip-action" style={{ cursor:'pointer' }} onClick={onOpenPanel}><i className="pi pi-plus" /> {t('product.add_filter')}</button>
      </div>
      {/* Bottom row: active filter chips — grow/shrink here without moving the controls above. */}
      <div className="pux-chips-row" style={{ paddingTop:0 }}>
        <span style={{ color:'#6b7280', fontSize:'.8rem' }}>{t('product.filter')}:</span>
        {activeFilters.length === 0 && <span style={{ color:'#9ca3af', fontSize:'.8rem' }}>{t('product.no_active_filter')}</span>}
        {activeFilters.map(f => (
          <span key={f.key} className="pux-fchip">{f.label}<button onClick={f.onRemove}><i className="pi pi-times" /></button></span>
        ))}
        {activeFilters.length > 0 && <button type="button" className="pux-fchip pux-fchip-clear" style={{ cursor:'pointer' }} onClick={onClearAll}>{t('actions.clear_filters')}</button>}
      </div>
    </div>
  );
}
